export default __webpack_public_path__ + "static/media/crescent.d5bb702c.svg";